import Donut from "./Donut";

const useGrafic = () => {
  return { Donut };
};
export default useGrafic;
